import { memo } from "react"

import { BaseTopBar } from "../TopBars/BaseTopBar"

export const FormSettingsViewTopBar = memo(() => {
	return <BaseTopBar showAIButton={false} />
})
FormSettingsViewTopBar.displayName = "FormSettingsViewTopBar"
